/**
 * The SKU as the seller wrote it.
 *
 * Mercado Libre stores whatever went into the listing's custom field, and a
 * listing built from a variation carries the variation's id welded onto the
 * end: the seller's "341128" comes back as "341128__25700535". Everything
 * from the double underscore on is the tool's bookkeeping, not the code the
 * seller looks up in their own records.
 *
 * Display only. The stored value stays whole, because that is what order
 * lines are matched against.
 */
export function shortSku(value) {
  if (!value) return '';
  return String(value).split('__')[0].trim() || String(value);
}
